module.exports = "/assets/data/9151d8c24407b86e46ca3ed4e68dbdb3-HU9.data.json";